import _decorate from "@oxc-project/runtime/helpers/decorate";

//#region src/utils.ts
function staticImplements() {
	return (constructor) => {};
}

//#endregion
//#region src/AuthService.ts
let AuthService = class AuthService$1 {
	_storage;
	_token = null;
	_refreshToken = null;
	static _instance;
	static instance() {
		if (!this._instance) this._instance = new this();
		return this._instance;
	}
	static config({ storage }) {
		this.instance()._storage = storage;
	}
	static token() {
		return Promise.resolve(this.instance().token());
	}
	static setToken(token) {
		return Promise.resolve(this.instance().setToken(token));
	}
	static clearToken() {
		return Promise.resolve(this.instance().clearToken());
	}
	static refreshToken() {
		return Promise.resolve(this.instance().refreshToken());
	}
	static setRefreshToken(token) {
		return Promise.resolve(this.instance().setRefreshToken(token));
	}
	static clearRefreshToken() {
		return Promise.resolve(this.instance().clearRefreshToken());
	}
	token() {
		this._token = this._token || this._storage?.getItem("authToken") || null;
		return this._token;
	}
	setToken(token) {
		this._token = token;
		this._storage?.setItem("authToken", token);
		return this._token;
	}
	clearToken() {
		this._token = null;
		this._storage?.removeItem("authToken");
	}
	refreshToken() {
		this._refreshToken = this._refreshToken || this._storage?.getItem("refreshToken") || null;
		return this._refreshToken;
	}
	setRefreshToken(token) {
		this._refreshToken = token;
		this._storage?.setItem("refreshToken", token);
		return this._refreshToken;
	}
	clearRefreshToken() {
		this._refreshToken = null;
		this._storage?.removeItem("refreshToken");
	}
};
AuthService = _decorate([staticImplements()], AuthService);

//#endregion
export { AuthService };